import ServiceLayout from "../components/ServiceLayout";

export default function CloudSolutions(){
  return(
    <ServiceLayout
      title="Cloud Solutions"
      subtitle="Secure infrastructure for modern businesses."
      gradient="linear-gradient(135deg,#667eea,#764ba2)"
      features={[
        "AWS Deployment",
        "Azure Services",
        "Cloud Migration",
        "DevOps Pipelines",
        "Auto Scaling",
        "Monitoring Tools"
      ]}
    />
  );
}
